<template>
<div class='loginPage'>
  
  <div style="font-size:20px; font-style:italic;" v-if="checkBrowser()">Zalecamy korzystanie z systemu z poziomu przeglądarek Firefox, Chrome, Opera<br></div>
  <div id="app">
    
    <p class = 'proj-title'> System TLK/TLI</p>
    <img src="../assets/aotmit_logo.png" width="100px" alt="Logo AOTMiT"/>
    <h1>Logowanie</h1>
    
    <span v-if="!change">
    <input v-on:keydown.enter="submit()"
      type="text"
      class="input-group"
      name="username"
      v-model="credentials.username"
      placeholder="Login"
    />
    <input v-on:keydown.enter="submit()"
      type="password"
      class="input-group password"
      name="password"
      v-model="credentials.password"
      placeholder="Hasło"
    />
    <div style='margin:auto; text-align:center;'>
      <button v-on:click="submit()" class='defButton' >Zaloguj</button>
      <!-- <button @click="$router.push('/')" class='defButton'>Anuluj</button> -->
    </div>
    </span>
    <span v-if="change">
      <input 
      type="text"
      class="input-group"
      name="usernameChange"
      v-model="credentials.usernameChange"
      placeholder="login"
    />
    <input 
      type="password"
      class="input-group password"
      name="passwordOld"
      v-model="credentials.OldPassword"
      placeholder="stare hasło"
    />

     
   <input 
      type="password"
      class="input-group password"
      name="passwordNew1"
      v-model="credentials.NewPassword1"
      placeholder="nowe hasło"
    />
     
    <input  
      type="password"
      class="input-group password"
      name="passwordNew2"
      v-model="credentials.NewPassword2"
      placeholder="powtórz nowe hasło"
    />
    <div  style='margin:auto; text-align:center;'>
      <button v-on:click="changePass()" class='defButton'>Zatwierdź zmianę</button>
      <button v-on:click="change=false" class='defButton'>Anuluj</button>
    </div>
    </span>
    <br><br>
    <span class="changePass" style="text-align:right; font-size:10px;margin-right:8px;" v-if="!change" @click="change=!change">
     <span class="changePassText"> Zmień hasło</span>
    </span><br>
    <!-- <button type='button' @click="recaptcha()">Execute recaptcha</button> -->
  </div>
  <modal name="badLogin" styles="padding: 40px;" :width="500" :height="150">
      Niepoprawny login lub hasło<br><br>
      <span class='download' style="color: #5597b4;" @click="$modal.hide('badLogin')"><strong>OK</strong></span>
  </modal>
  <modal name="badData" styles="padding: 40px; text-align:center;" :width="500" :height="150">
        {{message}}
      <br><br>
      <span class='download' style="color: #5597b4;" @click="HideOrNot()"><strong>OK</strong></span>
    </modal>
</div>
</template>

<script>
import auth from '../auth'
import { mapState, mapActions } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      credentials: {
        username: "",
        password: "",
        usernameChange:"",
        OldPassword:"",
        NewPassword:"",
        NewPassword1:""
      },
      change:false,
      message:""
    };
  },
  methods: {
    ...mapActions('user', ['changePassUser']),
      submit() {
        var credentials = {
          username: this.credentials.username,
          password: this.credentials.password
        }
        // We need to pass the component's this context
        
        // to properly make use of http in the auth service
        auth.login(this, credentials)
      },
      checkBrowser(){
       if(this.$browserDetect.isIE || this.$browserDetect.isEdge){return true}
       else{return false}
      },
      async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
 
      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
 
      // Do stuff with the received token.
    },
    checkData(params){
      console.log(params.new_password1 != params.new_password2)
      if(!params.username || !params.old_password || !params.new_password1 || !params.new_password2){
        this.message="Puste pola"
        this.$modal.show("badData"); return 0}
      if( params.new_password1 != params.new_password2){
        this.message="Nowe hasła nie są identyczne"
        this.$modal.show("badData");return 0}
      if(params.new_password1.length<6){
        this.message="Nowe hasło jest za krótkie (długość conajmniej 6 znaków)"
        this.$modal.show("badData");return 0}
      if( !/\d/.test(params.new_password1)){
        this.message="Nowe hasło musi zawierać zo najmniej jedną cyfrę"
        this.$modal.show("badData");return 0}

      this.changePassUser(params).then((response)=>{
        console.log(response)
        if(response=="Password changed."){
        this.message="Zmieniono hasło"}
        else {this.message = response}
        this.$modal.show("badData");return 0
      }).catch((error)=>{
        console.log("error2" +error)
      })


    },
    changePass(){
      this.message=''
      
      let params={
        username:this.credentials.usernameChange,
        old_password:this.credentials.OldPassword,
        new_password1:this.credentials.NewPassword1,
        new_password2:this.credentials.NewPassword2
      }
      this.checkData(params)
      
      
    },
    HideOrNot(){
      if(this.message=="Zmieniono hasło"){this.change=false}
      this.$modal.hide('badData')
    }
    }
};
</script>

<style scoped>
#app {
  width: 500px;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  margin: auto;
  /* margin-top: 200px; */
  margin-top: 8%;
  padding: 20px;

  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  padding: 1rem;
  box-shadow: 0 0 2rem rgba(0, 0, 0, 0.5);

  align-items: center;
  border-radius: 35px;
}

.loginPage{
  font-family: 'Arial' !important;
}

.input-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  width: 30rem;
}

.proj-title {
  font-size: 15px;
  font-style: italic;
}
.changePass{
  /* float: left !important; */
  width: 100%;
}
.changePassText:hover{
  cursor: pointer;
  text-decoration: underline;
}

</style>